import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useSearchParams } from "react-router-dom";
import { URL_HOSTING } from "../constants";
import {
  getPaymentStatus,
  getPaymentSessionByReference,
  PaymentStatus,
} from "../services/paymentSessionService";

const MercadoPagoStatus = () => {
  const [params] = useSearchParams();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkPayment();
  }, []);

  const getStatusValue = function (statusResponse) {
    if (!statusResponse) {
      return "";
    }

    return statusResponse.Status || statusResponse.status || "";
  };

  const getAmountValue = function (statusResponse) {
    if (!statusResponse) {
      return "";
    }
    console.log("statusResponse", statusResponse);
    return statusResponse.Amount || statusResponse.amount || "";
  };

  const getReferenceValue = function (statusResponse) {
    if (!statusResponse) {
      return "";
    }

    return statusResponse.Reference || statusResponse.reference || "";
  };

  const getPaymentSessionIdFromSession = function (session) {
    if (!session) {
      return "";
    }

    return (
      session.PaymentSessionId ||
      session.paymentSessionId ||
      session.Payment_Session_Id ||
      session.payment_session_id ||
      session.Id ||
      session.id ||
      ""
    );
  };

  const showSuccess = function (statusResponse) {
    const amount = getAmountValue(statusResponse);
    const reference = getReferenceValue(statusResponse);

    Swal.fire({
      title: "¡Gracias, tu pago fue confirmado!",
      icon: "success",
      html: `
        <p>El pago fue confirmado correctamente por el sistema.</p>
        ${amount ? `<p><strong>Monto:</strong> $${amount} MXN</p>` : ""}
        ${reference ? `<p><strong>Referencia:</strong> ${reference}</p>` : ""}
      `,
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `<a style="text-decoration:none;color:#FFFFFF" href=${URL_HOSTING}>Entendido</a>`,
    });
  };

  const showPending = function (statusResponse) {
    const amount = getAmountValue(statusResponse);

    Swal.fire({
      title: "Tu pago está pendiente",
      icon: "info",
      html: `
        <p>Mercado Pago todavía no confirma el pago.</p>
        <p>Si ya realizaste el pago, puede tardar unos minutos en reflejarse.</p>
        ${amount ? `<p><strong>Monto:</strong> $${amount} MXN</p>` : ""}
      `,
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `<a style="text-decoration:none;color:#FFFFFF" href=${URL_HOSTING}>Entendido</a>`,
    });
  };

  const showRejected = function () {
    Swal.fire({
      title: "El pago no fue completado",
      icon: "error",
      html: `
        <p>El pago fue rechazado, cancelado o no pudo completarse.</p>
        <p>Puedes intentar nuevamente con otra forma de pago.</p>
      `,
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `<a style="text-decoration:none;color:#FFFFFF" href=${URL_HOSTING}>Entendido</a>`,
    });
  };

  const showError = function (message) {
    Swal.fire({
      icon: "error",
      title: "No pudimos verificar el pago",
      text: message || "Hubo un error al consultar el estatus del pago.",
      confirmButtonText: `<a style="text-decoration:none;color:#FFFFFF" href=${URL_HOSTING}>Entendido</a>`,
      footer: "",
    });
  };

  const resolvePaymentSessionId = function () {
    const sessionFromUrl =
      params.get("payment_session_id") ||
      params.get("paymentSessionId") ||
      params.get("sessionId");

    const sessionFromLocal = localStorage.getItem(
      "mercadoPagoPaymentSessionId",
    );

    if (sessionFromUrl || sessionFromLocal) {
      return Promise.resolve(sessionFromUrl || sessionFromLocal);
    }

    const externalReference =
      params.get("external_reference") || params.get("externalReference");

    if (!externalReference) {
      return Promise.reject(
        "No se encontró la sesión ni la referencia externa del pago.",
      );
    }

    return getPaymentSessionByReference(externalReference).then(
      function (session) {
        const paymentSessionId = getPaymentSessionIdFromSession(session);

        if (!paymentSessionId) {
          throw "El API encontró la sesión por referencia, pero no regresó el identificador de la sesión.";
        }

        localStorage.setItem("mercadoPagoPaymentSessionId", paymentSessionId);

        return paymentSessionId;
      },
    );
  };

  const showStatusResult = function (statusResponse) {
    const status = getStatusValue(statusResponse);
    console.log("status", status);

    localStorage.removeItem("mercadoPagoPaymentSessionId");
    setChecking(false);

    if (status === PaymentStatus.PAID) {
      showSuccess(statusResponse);
      return;
    }

    if (status === PaymentStatus.PENDING) {
      showPending(statusResponse);
      return;
    }

    if (
      status === PaymentStatus.REJECTED ||
      status === PaymentStatus.CANCELLED ||
      status === PaymentStatus.REFUNDED
    ) {
      showRejected();
      return;
    }

    showPending(statusResponse);
  };

  const checkPayment = function () {
    resolvePaymentSessionId()
      .then(function (paymentSessionId) {
        return getPaymentStatus(paymentSessionId);
      })
      .then(function (statusResponse) {
        console.log("statusResponse", statusResponse);
        showStatusResult(statusResponse);
      })
      .catch(function (err) {
        const message =
          typeof err === "string"
            ? err
            : "Hubo un error al establecer conexión con el servidor.";

        setChecking(false);
        showError(message);
      });
  };

  return (
    <>
      {checking && (
        <div style={{ textAlign: "center", marginTop: 40 }}>
          Verificando el estatus de tu pago...
        </div>
      )}
    </>
  );
};

export default MercadoPagoStatus;
